import { useChatAttachmentQuery } from "web_myplann/Api/Chat/useChatAttachmentQuery";
import { useObjectUrl } from "web_myplann/Shared/Hooks/useObjectUrl";

export const useChatAttachmentImage = (
	attachmentId: number | undefined,
	enabled: boolean,
) => {
	const { data: blob, isError } = useChatAttachmentQuery(attachmentId, enabled);

	return { url: useObjectUrl(blob), isError };
};
